import { html, Html, View } from 'rune-ts';
import {
  CreatorProductData,
  EditCreatorProductData,
  EditCreatorProductData_TPL,
  EditCreatorProductData_TPL_INTL,
  NewCreatorProductData,
} from '@services/MarppleShopStudio/widget/CreatorProduct/core/types/types.ts';
import klass from './CreatorProductEditor.module.scss';
import {
  EditForm,
  EditForm_TPL,
  EditForm_TPL_INTL,
  NewForm,
} from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm';

export abstract class CreatorProductEditorBase<T extends CreatorProductData> extends View<T> {
  protected override template(): Html {
    return html` <div class="${klass.root}">${this.getProductFormView()}</div> `;
  }

  protected abstract getProductFormView(): View;
}

export class NewCreatorProductEditor extends CreatorProductEditorBase<NewCreatorProductData> {
  protected getProductFormView() {
    return new NewForm(this.data);
  }
}

export class EditCreatorProductEditor extends CreatorProductEditorBase<EditCreatorProductData> {
  protected getProductFormView() {
    return new EditForm(this.data);
  }
}

export class EditTplCreatorProductEditor extends CreatorProductEditorBase<EditCreatorProductData_TPL> {
  protected getProductFormView() {
    return new EditForm_TPL(this.data);
  }
}

export class EditTplIntlCreatorProductEditor extends CreatorProductEditorBase<EditCreatorProductData_TPL_INTL> {
  protected getProductFormView() {
    return new EditForm_TPL_INTL(this.data);
  }
}
